import { Injectable } from '@angular/core';
import { CoursesService } from '../courses/courses.service';
import { map, Observable, of } from 'rxjs';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Requirements } from './requirements.model';



function getCourseId(returnUrl: string): string | undefined {
  const re = /\/courses?\/([^\/]*)/;
  const match = re.exec(returnUrl);

  //console.log("getCourseId: returnUrl=", returnUrl, " match=", match);

  if (match) {
    console.log("getCourseId: found courseId=", match[1]);
    return match[1]
  } else {
    return undefined ;
  }

}

@Injectable({
  providedIn: 'root'
})
export class RequirementsService {

  constructor(
    private courses: CoursesService
  ) { }

  private getRequirementsFromCourseId(courseId: string): Observable<Requirements> {
      return this.courses.getCourse(courseId).pipe(
        map(result => {
            return result.requirements ;
          }
        )); 
  }

  getRequirementsFromRoute(route: ActivatedRouteSnapshot): Observable<Requirements>  {
    const courseId = route.params['courseId'] ;

    if (courseId)
      return this.getRequirementsFromCourseId(courseId) ;

    return of(new Requirements())
  }

  getRequirementsFromReturnUrl(returnUrl: string | undefined | null): Observable<Requirements> {

    if (!returnUrl)
      return of(new Requirements())


    const courseId = getCourseId(returnUrl);

    if (courseId)
      return this.getRequirementsFromCourseId(courseId) ;

    return of(new Requirements())
  }


}